import React, { Component } from "react";
import GuestHomePage from "../GuestHomePage/GuestHomePage";
import { checkCookie } from "../../Utils/Utils";
import MainPage from "../MainPage/MainPage";
import RedirectPage from "../Redirect/Redirect";
import { ENABLE_RESONATE_WEBSITE } from "../../../constants/Constants";

class HomePage extends Component {
  componentDidMount() {
    
    ENABLE_RESONATE_WEBSITE? this.setState({ redirectNbcfOnline: false }): this.setState({ redirectNbcfOnline: true });
    
    if (checkCookie("emailId")) {
      this.setState({ cookie: true });
    }

  }

  constructor(props) {
    super(props);

    this.state = {
      cookie: false
    };
  }

  render() { 
    return this.state.redirectNbcfOnline ? <RedirectPage/>: (this.state.cookie ? <MainPage /> : <GuestHomePage />);
  }
}

export default HomePage;
